import ListaControladoModel from "../../models/produto/listaControladoModel";
import { iServiceCached } from "../base/iServiceCached";

class ListaControladoService extends iServiceCached<ListaControladoModel> {
    constructor() {
        super("ListaControlado");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.codigo + " - " + p.descricao,
        }));
    }
}

export default new ListaControladoService();
